import { useQuery } from "@tanstack/react-query";
import { fetchOrders, fetchOrder, fetchOrderItems, type OrderStatus } from "@/lib/orders";

export function useOrders(status?: OrderStatus) {
  return useQuery({
    queryKey: ["orders", "list", status ?? "all"],
    queryFn: () => fetchOrders(status),
    staleTime: 15_000,
  });
}

export function useOrder(id: string | undefined) {
  return useQuery({
    queryKey: ["orders", "detail", id],
    queryFn: () => fetchOrder(id!),
    enabled: Boolean(id),
    staleTime: 15_000,
  });
}

export function useOrderItems(orderId: string | undefined) {
  return useQuery({
    queryKey: ["orders", "items", orderId],
    queryFn: () => fetchOrderItems(orderId!),
    enabled: Boolean(orderId),
    staleTime: 30_000,
  });
}
